import h from 'virtual-dom/h';
import createElement from 'virtual-dom/create-element';
import moment from 'moment';
import numeral from 'numeral';
import tippy from 'tippy.js';
import {getScheduledIsoWeekDates} from './dateHelpers';

const TOOLTIP_CELL_STYLE = 'color: #fff; background: transparent; padding: 6px 12px; white-space: nowrap;';
const TOOLTIP_HEADER_CELL_STYLE = `${TOOLTIP_CELL_STYLE} color: #000; font-weight: 600;`;

// Shared with the piece-rate ("stukprijzen") info icon so the two can never visually drift
// apart - see buildTooltipIcon.
function buildTooltipTable(headerRow: any, bodyRows: any[]): VirtualDOM.VNode {
    return h('table', { className: 'table-bordered tooltip-day-table' }, [h('thead', {}, [headerRow]), h('tbody', {}, bodyRows)]);
}

export function buildTooltipIcon(id: string): any {
    return h('span', { id, className: 'fa fa-info-circle', style: 'display: inline-block; margin-left: 5px' }, []);
}

export function attachHoursTooltip(item: any): void {
    const root = document.getElementById(`tooltip-hours-${item.id}`);
    if (root == null || !item.days || item.days.length === 0) {
        return;
    }

    const days = item.days.slice().sort((a: any, b: any) => a.date.localeCompare(b.date));

    const headerRow = h('tr', {}, days.map((d: any) => h('th', { style: TOOLTIP_HEADER_CELL_STYLE }, moment(d.date).format('dd D MMM'))));
    const bodyRow = h('tr', {}, days.map((d: any) => h('td', { style: TOOLTIP_CELL_STYLE }, moment.duration(d.timeWorked, 'ms').format('H:mm', { trim: false }))));

    tippy(root, { placement: 'bottom', allowHTML: true, maxWidth: 'none', content: createElement(buildTooltipTable(headerRow, [bodyRow])) });
}

export function attachCostItemDaysTooltip(item: any): void {
    const root = document.getElementById(`tooltip-costitem-days-${item.id}`);
    const costItemsWithDays = (item.extras ?? []).filter((e: any) => e.days && e.days.length > 0);
    if (root == null || costItemsWithDays.length === 0) {
        return;
    }

    const allDates = item.weekNumber != null && item.year != null
        ? getScheduledIsoWeekDates(item.year, item.weekNumber, item.daysOfWeek ?? []).map((d) => d.format('YYYY-MM-DD'))
        : Array.from(new Set(costItemsWithDays.flatMap((e: any) => e.days.map((d: any) => d.date)))).sort();

    const headerRow = h('tr', {}, [
        h('th', { style: TOOLTIP_HEADER_CELL_STYLE }, ''),
        ...allDates.map((date) => h('th', { style: TOOLTIP_HEADER_CELL_STYLE }, moment(date as string).format('dd D MMM'))),
        h('th', { style: TOOLTIP_HEADER_CELL_STYLE }, 'Totaal'),
    ]);
    const bodyRows = costItemsWithDays.map((extra: any) => {
        const total = allDates.reduce((sum: number, date) => {
            const day = extra.days.find((d: any) => d.date === date);
            return sum + (day?.amount ?? 0);
        }, 0);
        return h('tr', {}, [
            h('td', { style: TOOLTIP_CELL_STYLE }, extra.description),
            ...allDates.map((date) => {
                const day = extra.days.find((d: any) => d.date === date);
                return h('td', { style: TOOLTIP_CELL_STYLE }, numeral(day?.amount ?? 0).format('0,0.00'));
            }),
            h('td', { style: `${TOOLTIP_CELL_STYLE} font-weight: 600;` }, numeral(total).format('0,0.00')),
        ]);
    });

    tippy(root, { placement: 'bottom', allowHTML: true, maxWidth: 'none', content: createElement(buildTooltipTable(headerRow, bodyRows)) });
}
